'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scroll = void 0;
const $ = require("jquery");
class Scroll {
    constructor() {
        // スクロールトップ
        $('.trigTop').on('click', (e) => {
            $('html, body').animate({ scrollTop: 0 }, 300);
        });
    }
}
exports.Scroll = Scroll;
exports.default = Scroll;
